import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const PromoRedirect = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Obtener todos los parámetros de tracking
    const promoCode = searchParams.get('promo');
    const source = searchParams.get('source') || searchParams.get('utm_source');
    const date = searchParams.get('date');
    const time = searchParams.get('time');
    const guests = searchParams.get('guests');
    
    // Guardar el código promocional si existe
    if (promoCode) {
      sessionStorage.setItem('promo_code', promoCode);
      console.log(`Código promocional capturado: ${promoCode}`);
    }
    
    // Guardar el source si existe
    if (source) {
      sessionStorage.setItem('tracking_source', source);
      console.log(`Origen capturado: ${source}`);
    }
    
    // Guardar otros parámetros si vienen
    if (date || time || guests) {
      sessionStorage.setItem('promoReservation', JSON.stringify({
        date: date || '',
        time: time || '',
        guests: guests ? parseInt(guests) : 2,
        promo: promoCode,
        source: source
      }));
    }
    
    // Redirigir a la página de reservas
    navigate('/');
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#e31837] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600">Procesando tu solicitud...</p>
      </div>
    </div>
  );
};

export default PromoRedirect;